var _module_exports ="";;
var path = '/app/Main/userRequest/userRequestEdit/TaskCatalog.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;